import React from 'react'
import { StyledAchievementsGrid, StyledNextButton } from './achievements.style'
import AchievementItem from './achievement-item'
import { ModuleHeader } from '../module-header'
import {
    MdNavigateNext
} from "react-icons/md";


const Achievements = ({ type }) => {
    return (
        <>
            <ModuleHeader title="ACHIEVEMENTS" />
            <div style={{ position: 'relative' }}>
                {!type && (
                    <StyledNextButton>
                        <MdNavigateNext />
                    </StyledNextButton>
                )}

                <StyledAchievementsGrid>
                    <AchievementItem
                        bgColor="#58B7C2"
                        achievementDate="January 12, 2021"
                        achievementType="Best Student in Class"
                    />
                    <AchievementItem
                        bgColor="#2196F3"
                        achievementDate="December 4, 2020"
                        achievementType="Topped Class in Quiz"
                    />
                    {type === 'results' && (
                        <>
                            <AchievementItem
                                bgColor="#FF348E"
                                achievementDate="November 12, 2020"
                                achievementType="Top 5 in Class"
                            />
                            <AchievementItem
                                bgColor="#58B7C2"
                                achievementDate="September 4, 2020"
                                achievementType="Top 5 in Class"
                            />
                        </>
                    )}
                </StyledAchievementsGrid>
            </div>
        </>
    )
}

export { Achievements }
